
namespace GeniuzPOS.Purchase {
    import fld = ListAppInvoiceReceiveRow.Fields


    @Serenity.Decorators.registerClass()
    export class ListAppInvoiceReceiveGrid extends Serenity.EntityGrid<ListAppInvoiceReceiveRow, any> {
        protected getColumnsKey() { return ListAppInvoiceReceiveColumns.columnsKey; }
        protected getDialogType() { return ListAppInvoiceReceiveDialog; }
        protected getIdProperty() { return ListAppInvoiceReceiveRow.idProperty; }
        protected getInsertPermission() { return ListAppInvoiceReceiveRow.insertPermission; }
        protected getLocalTextPrefix() { return ListAppInvoiceReceiveRow.localTextPrefix; }
        protected getService() { return ListAppInvoiceReceiveService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            // let self = this;
            // self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            let filters = super.getQuickFilters();


             

            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.Username == Authorization.userDefinition.Username);
             var userapprole = Q.tryFirst(Administration.UserApprovalRoleRow.getLookup().items, x => x.UserId == userId.UserId);


            Q.first(filters, x => x.field == fld.WaitApprove).init = w => {

                (w as Serenity.StringEditor).value = userapprole?.ApprGroupCode ?? "";
               
            };
         

            return filters;
        }
    }
}